import { CX_ASYNC_SKIPPED_QUESTION_IDS, localStorageGetItem, localStorageSetItem } from '@utils/localStorageHelpers';
const parseStoredSkippedQuestionIds = (rawValue) => {
    if (!rawValue)
        return [];
    try {
        const parsed = JSON.parse(rawValue);
        if (!Array.isArray(parsed))
            return [];
        return parsed
            .filter((id) => typeof id === 'string' || typeof id === 'number')
            .map((id) => String(id));
    }
    catch {
        return [];
    }
};
/** Reserved for CX-3466 API integration. */
export const getSkippedQuestionIds = () => parseStoredSkippedQuestionIds(localStorageGetItem(CX_ASYNC_SKIPPED_QUESTION_IDS) ?? null);
export const addSkippedQuestionId = (questionId) => {
    if (questionId === undefined || questionId === null)
        return;
    const nextId = String(questionId);
    const existingIds = getSkippedQuestionIds();
    if (existingIds.includes(nextId))
        return;
    localStorageSetItem(CX_ASYNC_SKIPPED_QUESTION_IDS, JSON.stringify([...existingIds, nextId]));
};
export const removeSkippedQuestionId = (questionId) => {
    if (questionId === undefined || questionId === null)
        return;
    const nextId = String(questionId);
    const existingIds = getSkippedQuestionIds();
    const filteredIds = existingIds.filter((id) => id !== nextId);
    localStorageSetItem(CX_ASYNC_SKIPPED_QUESTION_IDS, JSON.stringify(filteredIds));
};
